/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

document.addEventListener('DOMContentLoaded', function () {
  const Header = document.querySelector('[data-site-header]');

  function updateHeaderBackground() {
    if (window.innerWidth >= 768) {
      Header.classList.remove('site-header--compress');
    } else {
      Header.classList.add('site-header--compress');
    }
  }

  // Run on page load
  updateHeaderBackground();

  // Listen for window resize
  window.addEventListener('resize', updateHeaderBackground);
});




  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
